module.exports = __webpack_public_path__ + "img/abu.7e9ced8.webp";